import {field} from "../../../stem-core/state/StoreField.js";
import {apiClient} from "../../connection/BlinkApiClient.js";
import {BaseStore, globalStore} from "../../../stem-core/state/Store";
import {Merchant} from "../MerchantStore";


@globalStore
export class MerchantEmailSender extends BaseStore("MerchantEmailSender") {
    @field("Merchant") merchant: Merchant;
    @field(String) emailAddress: string;
    @field(String) name: string;

    toString(): string {
        return this.emailAddress;
    }
}

export async function apiMerchantCreateEmailSender(request: any): Promise<any> {
    return apiClient.post("merchant/create_email_sender/", request);
}

export async function apiMerchantUpdateEmailSender(request: any): Promise<any> {
    return apiClient.post("merchant/update_email_sender/", request);
}

export async function apiMerchantDeleteEmailSender(request: any): Promise<any> {
    return apiClient.post("merchant/delete_email_sender/", request);
}
